import NavbarSection from "@/components/LandingPage/Navbar/NavbarSection.vue";
import HeroSection from "@/components/LandingPage/Hero/HeroSection.vue";
import FeatureSection from "@/components/LandingPage/Features/FeatureSection.vue";
import FooterSection from "@/components/LandingPage/Footer/FooterSection.vue";

export default {
  name: "LandingPage",
  components: {
    NavbarSection,
    HeroSection,
    FeatureSection,
    FooterSection,
  },
};
